export default __webpack_public_path__ + "static/reuniao-atendimento-384fb6c483e6b0370e1623faea328aab.webp";